'use client'

import { cn } from '@utils'
import { CountUp } from 'countup.js'
import { isFunction } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

export default function Numbers({
  value,
  className,
  onStart,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & {
  value: number
  onStart?: () => void
}) {
  const countupRef = useRef<HTMLSpanElement>(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const el = countupRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true)
          observer.unobserve(el)
        }
      },
      {
        rootMargin: '0px',
        threshold: 1,
      }
    )
    observer.observe(el)

    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    const el = countupRef.current
    if (!el || !isInView) return

    const countUpAnim = new CountUp(el, value)
    if (!countUpAnim.error) {
      countUpAnim.start()
      if (isFunction(onStart)) {
        onStart()
      }
    } else {
      console.error(countUpAnim.error)
    }

    return () => {
      countUpAnim.reset()
      countUpAnim.pauseResume()
    }
  }, [value, isInView, onStart])

  return (
    <span
      ref={countupRef}
      className={cn({ 'opacity-0': !isInView }, className)}
      {...props}
    >
      {value}
    </span>
  )
}
